import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton } from '@mui/material';
import { Menu } from '@mui/icons-material';
import useAuth from '../../hooks/useAuth';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom'; // React Router v6 hook for navigation
import { useTheme } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';
import Tooltip from '@mui/material/Tooltip';
import LanguageSwitcher from './LanguageSwitcher'; // Import your LanguageSwitcher component


import Logo from '../../assets/CSC_White_Logo.png'; // Adjust path accordingly


const StyledAppBar  = styled(AppBar)`
  z-index: 1201;
`;

const FlexGrow = styled('div')`
  flex-grow: 1;
`;

const LogoImage = styled('img')`
  height: 50px; // Adjust the size as needed
  width: auto;
`;

const Header = ({ toggleDrawer }) => {
    const { logout } = useAuth();
    const navigate = useNavigate(); // Hook for redirecting to different routes
    const theme = useTheme();

    const handleLogout = () => {
        logout();
        navigate('/'); // Redirect to login page after logout
    };

    return (
        <StyledAppBar position="fixed" color="primary">
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={toggleDrawer}
                    sx={{ marginRight: 2 }}
                >
                    <Menu />
                </IconButton>
                {/* <Typography variant="h6" noWrap>
                    QSMP - CSC
                </Typography> */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <LogoImage src={Logo} alt="CSC Logo" />
                </Box>
                <FlexGrow />
                <LanguageSwitcher />
                <Tooltip title="Logout" arrow>
                    <IconButton color="inherit" onClick={handleLogout}>
                        <LogoutIcon/>
                    </IconButton>
                </Tooltip>
            </Toolbar>
        </StyledAppBar>
    );
};

export default Header;
